<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,0C3.58,0,0,3.58,0,8C0,12.42,3.58,16,8,16C12.42,16,16,12.42,16,8C16,3.58,12.42,0,8,0C8,0,8,0,8,0ZM8,14C4.69,14,2,11.31,2,8C2,4.69,4.69,2,8,2C11.31,2,14,4.69,14,8C14,11.31,11.31,14,8,14C8,14,8,14,8,14ZM8,5C6.34,5,5,6.34,5,8C5,9.66,6.34,11,8,11C9.66,11,11,9.66,11,8C11,6.34,9.66,5,8,5C8,5,8,5,8,5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Selection',
} as DefineComponent
</script>
